import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Box, CircularProgress, Alert } from '@mui/material';

import PurchaseOrderForm from './PurchaseOrderForm';
import { getPurchaseOrder, updatePurchaseOrder } from '../../collections/purchaseOrders';

const EditPurchaseOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [purchaseOrder, setPurchaseOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadPurchaseOrder = async () => {
      try {
        const po = await getPurchaseOrder(id);
        
        // Check if PO can be edited (only DRAFT status)
        if (po.status !== 'DRAFT') {
          setError('Chỉ có thể chỉnh sửa đơn hàng ở trạng thái nháp.');
          setLoading(false);
          return;
        }
        
        setPurchaseOrder(po);
      } catch (error) {
        console.error('Failed to load purchase order:', error);
        setError('Không thể tải đơn đặt hàng. Vui lòng thử lại.');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadPurchaseOrder();
    }
  }, [id]);

  const handleUpdatePurchaseOrder = async (formData) => {
    try {
      await updatePurchaseOrder(id, formData);
      toast.success('Cập nhật đơn đặt hàng thành công!', {
        position: 'top-center',
        autoClose: 2000,
      });
      navigate('/purchase-orders');
    } catch (error) {
      let errorMessage = "Đã xảy ra lỗi không xác định!";
      if (error.response?.data?.error) {
        if (typeof error.response.data.error === 'string') {
          errorMessage = error.response.data.error;
        } else if (typeof error.response.data.error === 'object') {
          errorMessage = Object.values(error.response.data.error).flat().join('; ');
        }
      }
      toast.error(errorMessage, {
        position: 'top-center',
        autoClose: 3000,
      });
      throw error;
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress size={60} sx={{ color: '#0e2a04' }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <PurchaseOrderForm 
      onSubmit={handleUpdatePurchaseOrder}
      initialData={purchaseOrder}
      isEdit={true}
    />
  );
};

export default EditPurchaseOrder;